<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.skTitle" style="width: 200px;" size="small" placeholder="请输入标题"
                        clearable @keyup.enter.native="partserch"></el-input>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增关键值</el-button>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" row-key-field-name="skId" style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增/编辑弹窗 -->
            <el-dialog :title="edit == true ? '编辑关键值' : '新增关键值'" :visible.sync="dialog" width="70%"
                custom-class="syskey-dialog" :close-on-click-modal="false" @close="onDialogClosed">
                <el-form ref="formRef" :model="form" label-position="top" :rules="rules" class="syskey-form">
                    <el-form-item label="标题" prop="skTitle">
                        <el-input v-model="form.skTitle" placeholder="请输入标题" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="值1" prop="skValue">
                        <div class="rich-editor-wrap" v-if="editorVisible">
                            <Toolbar :editor="editorValueOne" :defaultConfig="toolbarConfig" :mode="editorMode" />
                            <Editor v-model="form.skValue" :defaultConfig="editorConfig" :mode="editorMode"
                                @onCreated="onEditorOneCreated" @onChange="onEditorOneChange" />
                        </div>
                    </el-form-item>
                    <el-form-item label="值2" prop="skValueTwo">
                        <div class="rich-editor-wrap" v-if="editorVisible">
                            <Toolbar :editor="editorValueTwo" :defaultConfig="toolbarConfig" :mode="editorMode" />
                            <Editor v-model="form.skValueTwo" :defaultConfig="editorConfig" :mode="editorMode"
                                @onCreated="onEditorTwoCreated" @onChange="onEditorTwoChange" />
                        </div>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleClose()">取 消</el-button>
                    <el-button type="primary" @click="SureBtn">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
// 关键值配置页：对接后端 SysKeyController（/sys-key）
// 字段：skId、skTitle(标题)、skValue(值1富文本)、skValueTwo(值2富文本)
// 后端仅提供 列表/详情/新增/修改 四个接口，无删除，故页面不提供删除操作
// 值1/值2 为富文本，使用 wangEditor 编辑；表格列内用 v-html 原样渲染富文本
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import '@wangeditor/editor/dist/css/style.css';
import { getSysKeyList, addSysKey, updateSysKey } from "../../api/api";

export default {
    name: "sysKey",
    // 富文本编辑器组件（wangEditor Vue2 版），局部注册
    components: { Editor, Toolbar },
    data() {
        return {
            dialog: false,
            edit: false,
            form: {
                skId: null,
                skTitle: '',
                skValue: '',
                skValueTwo: '',
            },
            rules: {
                skTitle: [
                    { required: true, message: '请输入标题', trigger: 'blur' }
                ],
            },
            // ===== 富文本相关 =====
            // 控制富文本区域 v-if：每次打开抽屉后置 true 重建编辑器，关闭时置 false 销毁
            // 确保 form.skValue/skValueTwo 的最新值总能正确初始化进编辑器
            editorVisible: false,
            editorMode: 'default', // 编辑器模式：default 完整 / simple 简洁
            // 两个编辑器实例（值1、值2 各一个），需分别引用以便销毁
            editorValueOne: null,
            editorValueTwo: null,
            toolbarConfig: {
                // 排除部分不常用菜单，保持编辑器简洁
                excludeKeys: [
                    'group-video', // 去掉插入网络视频
                    'fullScreen',  // 去掉全屏
                ],
            },
            editorConfig: {
                placeholder: '请输入内容',
                // 弹层菜单（如颜色选择、表情）默认挂到 body，避免被抽屉/表格裁剪
                MENU_CONF: {},
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            totalCount: 0,
            // 表格列：序号 + 标题 + 值1(v-html富文本+复制) + 值2(v-html富文本+复制) + 操作(仅编辑)
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 80,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "skTitle",
                    key: "skTitle",
                    title: "标题",
                    align: "center",
                    edit: false,
                },
                {
                    field: "skValue",
                    key: "skValue",
                    title: "值1",
                    align: "center",
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        // 富文本内容原样渲染（domPropsInnerHTML 等价于 v-html）
                        return (
                            <div class="rich-cell">
                                <div class="rich-cell__html" domPropsInnerHTML={row.skValue}></div>
                            </div>
                        );
                    },
                },
                {
                    field: "skValueTwo",
                    key: "skValueTwo",
                    title: "值2",
                    align: "center",
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div class="rich-cell">
                                <div class="rich-cell__html" domPropsInnerHTML={row.skValueTwo}></div>
                            </div>
                        );
                    },
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 120,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                            </span>
                        );
                    },
                },
            ],
            tableData: [],
            formDatas: {
                skTitle: '',
                currentPage: 1,
                pageSize: 20,
            },
            watchFlag: false,
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    // 组件销毁前释放富文本编辑器实例，避免内存泄漏
    beforeDestroy() {
        this.destroyEditors();
    },
    methods: {
        // 打开编辑抽屉
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            // 确保 skId 存在
            if (data.skId !== undefined && data.skId !== null) {
                this.form.skId = data.skId;
            }
            this.$nextTick(() => {
                // 先赋值 form，再置 editorVisible 重建编辑器，使编辑器以当前 HTML 初始化
                this.form.skTitle = data.skTitle || '';
                this.form.skValue = data.skValue || '';
                this.form.skValueTwo = data.skValueTwo || '';
                this.$nextTick(() => {
                    this.editorVisible = true;
                });
            })
        },
        // 新增/编辑提交（带二次确认）
        SureBtn() {
            this.$refs['formRef'].validate((valid) => {
                if (!valid) {
                    return;
                }
                if (!this.edit) {
                    this.$confirm("是否确定要新增, 是否继续?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        addSysKey(this.form).then(res => {
                            if (res.data) {
                                this.$message({ type: "success", message: "新增成功!" });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({ type: "info", message: "已取消" });
                    })
                } else {
                    this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        updateSysKey(this.form).then(res => {
                            if (res.data) {
                                this.$message({ type: "success", message: "编辑成功!" });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({ type: "info", message: "已取消" });
                    })
                }
            })
        },
        BoxOpen() {
            this.dialog = true;
            // 打开弹窗：form 已为空值，下一帧重建富文本编辑器
            this.$nextTick(() => {
                this.editorVisible = true;
            });
        },
        // 触发关闭（仅切换显隐，清理统一交给 @close → onDialogClosed，避免重复执行）
        handleClose() {
            this.dialog = false;
        },
        // 弹窗关闭后真正的清理：销毁富文本编辑器并重置表单
        onDialogClosed() {
            this.editorVisible = false;
            this.edit = false;
            this.form = {
                skId: null,
                skTitle: '',
                skValue: '',
                skValueTwo: '',
            };
            this.$nextTick(() => {
                if (this.$refs['formRef']) {
                    this.$refs['formRef'].resetFields();
                }
            });
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            getSysKeyList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            getSysKeyList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
        getList() {
            getSysKeyList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
        // ===== 富文本编辑器回调 =====
        // 值1编辑器创建完成，保存实例引用（供工具栏绑定与销毁使用）
        onEditorOneCreated(editor) {
            this.editorValueOne = editor;
        },
        // 值2编辑器创建完成
        onEditorTwoCreated(editor) {
            this.editorValueTwo = editor;
        },
        // 编辑器内容变化时，wangEditor 已通过 v-model 同步到 form.skValue/skValueTwo，此处预留扩展
        onEditorOneChange(editor) { },
        onEditorTwoChange(editor) { },
        // 销毁两个编辑器实例，释放资源
        destroyEditors() {
            if (this.editorValueOne) {
                this.editorValueOne.destroy();
                this.editorValueOne = null;
            }
            if (this.editorValueTwo) {
                this.editorValueTwo.destroy();
                this.editorValueTwo = null;
            }
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

/* ===== 富文本编辑器（弹窗内） ===== */
.rich-editor-wrap {
    width: 100%;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
    z-index: 2003; /* 高于弹窗遮罩，确保下拉菜单（颜色/表情）正常显示 */
}

.rich-editor-wrap .w-e-toolbar {
    border-bottom: 1px solid #dcdfe6 !important;
}

.rich-editor-wrap .w-e-text-container {
    min-height: 200px;
}

/* ===== 弹窗样式 ===== */
.syskey-dialog .el-dialog__body {
    padding: 16px 24px;
    max-height: 65vh;
    overflow-y: auto;
}

.syskey-form .el-form-item {
    margin-bottom: 18px;
}

/* 表单项内输入框/编辑器撑满宽度 */
.syskey-form .el-input,
.syskey-form .el-textarea__inner {
    width: 100%;
}

/* ===== 表格富文本单元格：原样渲染 HTML，限高避免行高参差 ===== */
.rich-cell {
    text-align: left;
    padding: 4px 8px;
}

.rich-cell__html {
    max-height: 120px;
    overflow-y: auto;
    word-break: break-word;
    /* 限制富文本内图片宽度，防止撑破表格 */
    line-height: 1.5;
}

.rich-cell__html img {
    max-width: 100% !important;
    height: auto !important;
}

.rich-cell__html p {
    margin: 4px 0;
}
</style>
